import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PercentageValidation, requiredValidator } from 'app/modules/common/validation/common-validation';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';

@Component({
    selector: 'app-multi-atribute-popup',
    templateUrl: './multi-atribute-popup.component.html',
    styleUrls: ['./multi-atribute-popup.component.scss'],
    standalone: false
})
export class MultiAtributePopupComponent implements OnInit {

  PercentageForm: UntypedFormGroup;
  KeyValueArray: Array<{ key: string, value: string }> = [];
  ShowEditPanel = false;
  Operation: string;
  EditedIndex = -1;

  constructor(
    public dialogRef: MatDialogRef<MultiAtributePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public InputData: any,
    public fb: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {
    this.InitForm();
    const keyValPairs: Array<string> = (this.InputData.Value.length > 0) ? this.InputData.Value.trim().split('|') : '';
    if (keyValPairs.length > 0) {
      keyValPairs.forEach(keyVal => {
        const disecElems: Array<string> = keyVal.trim().split(String.fromCharCode(160));
        this.KeyValueArray.push({ key: disecElems[0], value: disecElems[1] });
      });
    }
  }

  InitForm(): void {
    this.PercentageForm = this.fb.group({
      key: ['', requiredValidator()],
      value: ['', [requiredValidator(), PercentageValidation()]],
    });
  }

  Delete(elem: { key: string, value: string }): void {
    const index: number = this.KeyValueArray.findIndex(x => x.key === elem.key && x.value === elem.value);
    this.KeyValueArray.splice(index, 1);
  }

  Add(): void {
    this.Operation = 'Add';
    this.ShowEditPanel = true;
  }

  Edit(elem: { key: string, value: string }): void {
    this.Operation = 'Edit';
    this.ShowEditPanel = true;
    // find the original place
    this.EditedIndex = this.KeyValueArray.findIndex(x => x.key === elem.key && x.value === elem.value);
    // set the original values to new KeyValue items.
    this.PercentageForm.setValue({ key: elem.key, value: this.convertToNumericPercentage(elem.value) });
  }

  Confirm(): void {
    this.markFormGroupTouched(this.PercentageForm);
    this.PercentageForm.updateValueAndValidity();
    if (this.PercentageForm.valid) {
      this.ShowEditPanel = false;
      if (this.Operation === 'Edit') {
        this.KeyValueArray.splice(this.EditedIndex, 1);
        this.EditedIndex = -1;
      }
      this.KeyValueArray.push({ key: this.PercentageForm.value.key, value: this.convertToPercentageString(this.PercentageForm.value.value) });
      this.PercentageForm.reset();
      this.Operation = 'Add';
    }
  }

  private markFormGroupTouched(formGroup: UntypedFormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }


  Cancel(): void {
    this.dialogRef.close();
    this.PercentageForm.reset();
    this.EditedIndex = -1;
  }

  CreateSaveString(keyValArray: Array<{ key: string, value: string }>): string {
    let result: string = null;
    const tempArray: Array<string> = [];
    keyValArray.forEach(element => {
      const keyValPairString = `${String.fromCharCode(160)}${element.key}${String.fromCharCode(160)}${element.value}${String.fromCharCode(160)}`;
      tempArray.push(keyValPairString);
    });
    result = tempArray.join('|');
    return result;
  }

  Accept(): void {
    this.dialogRef.close({
      finalString: this.CreateSaveString(this.KeyValueArray),
      WorkingHourPercent: this.getTotalWorkingHours(),
    });
  }

  private convertToNumericPercentage(input: string): string {
    input = input.replace(',', '.');
    input = input.replace('%', '');
    return input;
  }

  private convertToPercentageString(input: string): string {
    input = input.replace('.', ',');
    input = `${input}%`;
    return input;
  }

  /**
   * Get total working hours
   */
  private getTotalWorkingHours(): number {
    // store total
    let total = 0.0;

    // calculate total percantage
    this.KeyValueArray.forEach(pair => {
      const val = pair.value.replace(",", ".");
      total += parseFloat(val.substr(0, val.length - 1));
    });

    return total;

  }

}
